import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'transform'
})
export class TransformPipe implements PipeTransform {

  transform(object: any, ftn: any, parse: any, field: any): any {
    console.log('ftn ' + ftn + ' parse: ' + parse + ' field: ' + field + ' object: ' + object);
    console.log('object', object);
    if(parse == 'true') { object = JSON.parse(object); }
    
    
    if(ftn = 'returnObject') {
      //console.log('returnObject', object);
      return object[field];
    }

  }
}
